import { render, staticRenderFns } from "./TeamMemberJoinRequests.vue?vue&type=template&id=bc21f1d4&"
import script from "./TeamMemberJoinRequests.vue?vue&type=script&lang=js&"
export * from "./TeamMemberJoinRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports